import React, { lazy } from 'react';

import { CustomerTreeProvider } from '../pages/customers/CustomerTree/provider';
import { getProductConfig } from '../config/products.js';
import { withFeatureFlag } from '../hooks/Helper.js';
import { AllowByUserRole, DenyByFlagFilter } from '../components/permission.js';
import ModalProvider from '../providers/modal.provider';
import TelegramSubscribeProvider from '../providers/telegram.provider';
import configs from '../config/app.js';
const Customers = lazy(() => import('../pages/customers/customers'));
const CustomerDetail = lazy(() => import('../pages/customers/customerDetail'));
const CustomerTree = lazy(() => import('../pages/customers/CustomerTree/index.jsx'));
const NoPage = lazy(() => import('../pages/nopage'));
const NewCustomer = lazy(() => import('../pages/customers/newCustomer'));
const EditCustomer = lazy(() => import('../pages/customers/editCustomer'));
const CustomerOrders = lazy(() => import('../pages/customers/customerOrders'));
const OrderDetail = lazy(() => import('../pages/customers/orderDetail'));
const CustomerProfile = lazy(() => import('../pages/customers/account/profile'));
const Shop = lazy(() => import('../pages/customers/Shop.jsx'));
const Autoship = lazy(() => import('../pages/customers/AutoShip.jsx'));
const Checkout = lazy(() => import('../pages/customers/checkout.jsx'));
const CommissionsDetail = lazy(() => import('../pages/customers/CommissionsDetail'));
const Profile = lazy(() => import('../pages/account/profile'));
const CustomerSecurity = lazy(() => import('../pages/customers/account/security'));
const CustomerMoneyOut = lazy(() => import('../pages/customers/account/moneyOut'));
const CustomerMoneyIn = lazy(() => import('../pages/customers/account/moneyIn'));
const CommissionsBonusDetail = lazy(
  () => import('../pages/customers/commissionsBonusDetail')
);
const CustomerTreeSettings = lazy(
  () => import('../pages/customers/account/treeSettings')
);
const MediaList = lazy(() => import('../pages/tools/mediaList'));
const Dashboard = lazy(() => import('../pages/customers/dashboard'));
const ManaraLink = lazy(() => import('../pages/maitryx/maitryx'));
const EminusIdeas = lazy(() => import('../pages/stock/eminusIdeas'));
const EcaStock = lazy(() => import('../pages/stock/ecaStock'));
const AutoshipCheckout = lazy(() => import('../pages/customers/autoshipCheckout.jsx'));
const EminusLink = lazy(() => import('../pages/eminus/eminus'));
const Eacho = lazy(() => import('../pages/eacho/eacho'));
const PloutosLink = lazy(() => import('../pages/ploutos/ploutos'));
const ECA = lazy(() => import('../pages/eca/eca'));
const Training = lazy(() => import('../pages/tools/training'));
const Course = lazy(() => import('../pages/customers/course'));
const AutoshipSummary = lazy(() => import('../pages/customers/autoshipSummary'));
const UpdateAutoship = lazy(() => import('../pages/customers/UpdateAutoship.jsx'));
const AddAutoship = lazy(() => import('../pages/customers/addAutoship'));
const UnProcessedOrders = lazy(() => import('../pages/customers/unProcessedOrders'));
const CommissionWalletTransactions = lazy(
  () => import('../pages/customers/commissionWalletTransactions')
);
const CreditWalletTransactions = lazy(
  () => import('../pages/customers/creditwallettransactions')
);
const Card = lazy(() => import('../pages/customers/account/card'));
const Signature = lazy(() => import('../pages/customers/account/signature'));
const EditInvestment = lazy(() => import('../pages/customers/editInvestment'));
const OrderSubscriptionDashboard = lazy(
  () => import('../pages/customers/orderSubscriptionDashboard')
);
const BusinessDashboard = lazy(() => import('../pages/customers/BusinessDashboard.jsx'));
const ForexHub = lazy(() => import('../pages/customers/forexHub'));
const StocksHub = lazy(() => import('../pages/customers/stocks'));
const LoginInformation = lazy(
  () => import('../pages/customers/account/loginInformation')
);
const Skie = lazy(() => import('../pages/customers/skie'));
const RFX = lazy(() => import('../pages/customers/forex/rfx'));
const SkieShop = lazy(() => import('../pages/customers/skieShop'));
const Educators = lazy(() => import('../pages/customers/educator'));
const Chart = lazy(() => import('../pages/customers/stocks/chart'));
const SkieCheckout = lazy(() => import('../pages/customers/skieCheckout'));

const ReportCenter = lazy(
  () => import('../pages/customers/ReportCenter/ReportCenter.jsx')
);
const AssociateReports = lazy(
  () => import('../pages/customers/ReportCenter/AssociateReports.jsx')
);
const AssociateReport = lazy(
  () => import('../pages/customers/ReportCenter/AssociateReport.jsx')
);
const Glossaries = lazy(() => import('../pages/customers/glossaries'));
const CryptoHub = lazy(() => import('../pages/customers/crypto'));
const UnAuthrisedPage = lazy(() => import('../pages/UnAuthrisedPage'));
const ProtectedBySubscription = lazy(() => import('../ProtectedBySubscription'));
const ReferralDashboard = lazy(() => import('../pages/customers/ReferralPage'));
const PaymentMethod = lazy(() => import('../pages/customers/PaymentMethod.jsx'));
const DashboardNew = lazy(() => import('../pages/dashboard/Dashboard.jsx'));
const KYCSubmission = lazy(() => import('../pages/customers/kyc'));
const UserSummary = withFeatureFlag({
  flagKey: 'USER_SUMMARY_PAGE',
  EnabledComponent: lazy(() => import('../pages/customers/UserSummary')),
  DisabledComponent: Dashboard,
});
const TeamsPage = withFeatureFlag({
  flagKey: 'REFACTOR_TEAMS',
  EnabledComponent: lazy(() => import('../pages/customers/teams/Teams')),
  DisabledComponent: lazy(() => import('../pages/customers/customers')),
});

const basePath = 'customers';
const idPath = ':customerId';
const focusPath = `${basePath}/${idPath}`;

const routes = [
  {
    path: 'profile',
    element: <Profile />,
  },
  {
    path: 'dashboard',
    element: <DashboardNew />,
  },
  {
    path: 'merchants',
    element: <PaymentMethod />,
  },
  {
    path: basePath,
    element: <Customers returnbtn={false} />,
  },
  {
    path: `${focusPath}/skie`,
    element: <Skie />,
  },
  {
    path: `${focusPath}/skie-shop`,
    element: <SkieShop />,
  },
  {
    path: `${focusPath}/skie-checkout`,
    element: <SkieCheckout />,
  },
  {
    path: `${focusPath}/chart`,
    element: <Chart />,
  },
  {
    path: `${focusPath}/educators`,
    element: <Educators />,
  },
  {
    path: `${focusPath}/Maitryx`,
    element: <ManaraLink />,
  },

  {
    path: `${focusPath}/ploutos`,
    element: <PloutosLink />,
  },
  {
    path: `${focusPath}/eacho`,
    element: <Eacho />,
  },
  {
    path: `${focusPath}/eca`,
    element: <ECA />,
  },
  {
    path: `${basePath}/new`,
    element: <NewCustomer />,
  },
  {
    path: `${focusPath}/edit`,
    element: <EditCustomer />,
  },
  {
    path: `${focusPath}/user-summary`,
    element: <UserSummary />,
  },
  {
    path: `${focusPath}/summary`,
    element: (
      <ModalProvider>
        <CustomerDetail />
      </ModalProvider>
    ),
  },
  {
    path: `${focusPath}/dashboard`,
    element: (
      <ModalProvider>
        <Dashboard />
      </ModalProvider>
    ),
  },
  {
    path: `${focusPath}/referral`,
    element: <ReferralDashboard />,
  },
  {
    path: `${focusPath}/edit-investment`,
    element: <EditInvestment />,
  },
  {
    path: `${focusPath}/orders`,
    element: (
      <ModalProvider>
        <CustomerOrders />
      </ModalProvider>
    ),
  },
  {
    path: `${focusPath}/associate-reports`,
    element: (
      <ModalProvider>
        <AssociateReports />
      </ModalProvider>
    ),
  },
  {
    path: `${focusPath}/create-associate-report/:type`,
    element: (
      <ModalProvider>
        <AssociateReport />
      </ModalProvider>
    ),
  },
  {
    path: `${focusPath}/edit-associate-report/:reportId`,
    element: (
      <ModalProvider>
        <AssociateReport />
      </ModalProvider>
    ),
  },
  {
    path: `${focusPath}/associate-report/:reportId?`,
    element: <ReportCenter />,
  },
  {
    path: `${focusPath}/orders/:orderId`,
    element: (
      <ModalProvider>
        <OrderDetail />
      </ModalProvider>
    ),
  },

  {
    path: `${focusPath}/autoship`,
    element: (
      <AllowByUserRole
        allowedRoles={['Admin', 'ClientAdmin']}
        redirect={`/customers/{{associateId}}/dashboard`}
      >
        <Autoship />
      </AllowByUserRole>
    ),
  },
  {
    path: `${focusPath}/autoshipsummary`,
    element: (
      <ModalProvider>
        <AutoshipSummary />
      </ModalProvider>
    ),
  },
  {
    path: `${focusPath}/updateautoship/:autoShipId`,
    element: <UpdateAutoship />,
  },
  {
    path: `${focusPath}/addautoship/:autoShipId`,
    element: <AddAutoship />,
  },
  {
    path: `${focusPath}/business-hub`,
    element: (
      <ProtectedBySubscription
        requiredSubscriptionId={getProductConfig(configs.clientId, 'businessHub')}
      >
        <ModalProvider>
          <DenyByFlagFilter
            flagName='BUSINESS_HUB_FILTER'
            redirect={`/`}
            focusValue={'account.associateId'}
          >
            <BusinessDashboard />
          </DenyByFlagFilter>
        </ModalProvider>
      </ProtectedBySubscription>
    ),
  },
  {
    path: `${focusPath}/business-hub/kyc`,
    element: (
      <ProtectedBySubscription
        requiredSubscriptionId={getProductConfig(configs.clientId, 'businessHub')}
      >
        <ModalProvider>
          <KYCSubmission />
        </ModalProvider>
      </ProtectedBySubscription>
    ),
  },
  {
    path: `${focusPath}/order-subscription`,
    element: (
      <ModalProvider>
        <OrderSubscriptionDashboard />
      </ModalProvider>
    ),
  },

  {
    path: `${focusPath}/rfx`,
    element: <RFX />,
  },
  {
    path: `${focusPath}/checkout`,
    element: <Checkout />,
  },
  {
    path: `${focusPath}/training`,
    element: <Training />,
  },
  {
    path: `${focusPath}/training/:courseId`,
    element: <Course />,
  },
  {
    path: `${focusPath}/account/profile`,
    element: <CustomerProfile />,
  },
  {
    path: `${focusPath}/account/login-info`,
    element: <LoginInformation />,
  },
  {
    path: `${focusPath}/account/security`,
    element: <CustomerSecurity />,
  },
  {
    path: `${focusPath}/account/moneyin`,
    element: <CustomerMoneyIn />,
  },
  {
    path: `${focusPath}/account/moneyout`,
    element: <CustomerMoneyOut />,
  },
  {
    path: `${focusPath}/account/card`,
    element: <Card />,
  },
  {
    path: `${focusPath}/account/signature`,
    element: <Signature />,
  },
  {
    path: `${focusPath}/account/treesettings`,
    element: <CustomerTreeSettings />,
  },
  {
    path: `${focusPath}/commissions`,
    element: <CommissionsDetail />,
  },
  {
    path: `${focusPath}/commissions/:bonusId`,
    element: <CommissionsBonusDetail />,
  },
  {
    path: `${focusPath}/tree/:treeId`,
    element: (
      <ModalProvider>
        <CustomerTreeProvider>
          <CustomerTree />
        </CustomerTreeProvider>
      </ModalProvider>
    ),
  },
  {
    path: `${focusPath}/autoshipcheckout`,
    element: <AutoshipCheckout />,
  },
  {
    path: `${focusPath}/commissionwallettransactions`,
    element: <CommissionWalletTransactions />,
  },
  {
    path: `${focusPath}/creditwallettransactions`,
    element: <CreditWalletTransactions />,
  },
  {
    path: `${focusPath}/eminus-ideas`,
    element: <EminusIdeas />,
  },
  {
    path: `${focusPath}/eca-stock`,
    element: <EcaStock />,
  },
  // DUPLICATE PATH - same element (ProtectedBySubscription requiredSubscriptionId={147} + CryptoHub)
  {
    path: `${focusPath}/crypto`,
    element: (
      <ProtectedBySubscription
        requiredSubscriptionId={getProductConfig(configs.clientId, 'lumenHub')}
      >
        <CryptoHub />
      </ProtectedBySubscription>
    ),
  },

  {
    path: `${focusPath}/glossaries/:category`,
    element: <Glossaries />,
  },
  {
    path: `${focusPath}/stocks`,
    element: <StocksHub />,
  },
  {
    path: `${focusPath}/media`,
    element: <MediaList />,
  },
  {
    path: `${focusPath}/unauthorized`,
    element: <UnAuthrisedPage />,
  },
  {
    path: 'inventory/products/unprocessedorders',
    element: <UnProcessedOrders />,
  },
  {
    path: '*',
    element: <NoPage />,
  },
  {
    path: `${focusPath}/eminus`,
    element: <EminusLink />,
  },
  {
    path: `${focusPath}/team`,
    element: <TeamsPage returnbtn={true} />,
  },
  {
    path: `${focusPath}/shop`,
    element: <Shop />,
  },
  {
    path: `${focusPath}/forex`,
    element: (
      <ProtectedBySubscription
        requiredSubscriptionId={getProductConfig(configs.clientId, 'forexHub')}
      >
        <TelegramSubscribeProvider>
          <ForexHub />
        </TelegramSubscribeProvider>
      </ProtectedBySubscription>
    ),
  },
];

// const disabledRoutes = [
//     {
//         path: 'page',
//         element: <Page />,
//         import: 'unknown'
//     },
//     {
//         path: 'customers/:customerId/subscription',
//         element: <Subscription />,
//         import: '../pages/customers/subscription'
//     }
// ]

export default routes;
